import { BadgeStatus } from "../dashboardOverview.types";

export interface StatusBadgeProps {
	label: string;
	tone: BadgeStatus;
}

const toneClassMap: Record<BadgeStatus, string> = {
	success: "cd-badge--success",
	warning: "cd-badge--warning",
	danger: "cd-badge--danger",
	info: "cd-badge--info",
	neutral: "cd-badge--neutral",
};

export const StatusBadge = ({ label, tone }: StatusBadgeProps) => {
	return <span className={`cd-badge ${toneClassMap[tone]}`}>{label}</span>;
};
